//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').constant('EcommerceIntegrationsActions', {
    CHANGE_VIEW: 'change_view',
    CHANGE_CONNECTING_STATE: 'change_connecting_state',
    CHANGE_TOKEN_VALIDATION_STATE: 'change_token_validation_state',
    INITIALIZE_INTEGRATION_TYPE: 'initialize_integration_type',
    SET_CATALOG_ID: 'set_catalog_id',
  });

  angular.module('curalate').constant('EcommerceIntegrationsView', {
    LOADING: 'loading',
    START: 'start',
    CONNECTED: 'connected',
    CONFIGURING_FORM: 'configuring_form',
    CONNECTING_ASYNC: 'connecting_async',
  });

  angular.module('curalate').constant('EcommerceIntegrationsAsyncStatusState', {
    NOT_CONNECTING: 'not_connecting',
    CONNECTING: 'connecting',
    FAILED_INGESTION: 'failed_ingestion',
    FAILED_TOKEN: 'failed_token',
    SUCCEEDED: 'succeeded',
    MORE_THAN_ONE: 'more_than_one',
  });

  angular.module('curalate').constant('EcommerceIntegratonsAddCatalogStatus', {
    SUCCESSFUL_SETUP: 'successful_setup',
    FAILURE_BAD_TOKEN: 'failure_bad_token', // TODO: eventually this can get pulled out w/ form validation
    FAILURE_CATALOG_ADD: 'failure_catalog_add',
    FAILURE_CLIENT_NOT_FOUND: 'failure_client_not_found',
    FAILURE_TOKEN_TIMEOUT: 'failure_token_timeout',
  });

  angular.module('curalate').constant('EcommerceIntegrationsOptions', {
    MAGENTO: 'ecommerce_integrations_magento',
    SHOPIFY: 'ecommerce_integrations_shopify',
  });

  angular.module('curalate').constant('ProductFeedHealthAcquisitionStatuses', {
    EMPTY: 'empty',
    PENDING: 'pending',
    SUCCESSFUL: 'successful',
    FAILURE: 'failure',
    MORE_THAN_ONE: 'more_than_one',
  });
})();
